import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  MODAL_CANCEL_BUTTON: `${cleanedFilename(__filename)}-modal-cancel-button`,
};
